import { useState } from "react";
import { useHistory } from "react-router-dom";

import styles from "./GlobalAdminsPage.module.css";
import classNames from "classnames";

import Header from "DreamStream/Shared/Header";
import AddGlobalAdminModal from "../AddGlobalAdminModal";
import Card from "../Card";
import GlobalAdminsList from "../GlobalAdminsList";
import RemoveGlobalAdminModal from "../RemoveGlobalAdminModal";

/**
 *
 * shows details about a specific group
 *
 */

export function GlobalAdminsPage({}) {
  const history = useHistory();
  const [addGlobalAdminModalOpen, setAddGlobalAdminModalOpen] = useState(false);

  var placeholderAdmins = [
    {
      adminName: "First Name Last Name",
      email: "email",
      accessLevel: "Global",
    },
    {
      adminName: "First Name Last Name",
      email: "email",
      accessLevel: "Global",
    },
    {
      adminName: "First Name Last Name",
      email: "email",
      accessLevel: "Global",
    },
    {
      adminName: "First Name Last Name",
      email: "email",
      accessLevel: "Global",
    },
  ];

  const [removeAdminModalOpen, setRemoveAdminModalOpen] = useState(false);
  const [removeAdminInfo, setRemoveAdminInfo] = useState(null);

  function clickRemove(adminInfo) {
    console.log(adminInfo);
    setRemoveAdminInfo(adminInfo);
    setRemoveAdminModalOpen(true);
  }

  function removeAdmin() {
    // TODO: call API method here
    alert("remove called: " + JSON.stringify(removeAdminInfo));
    setRemoveAdminModalOpen(false);
  }

  function addGlobalAdmin(admin) {
    // TODO: call API method here
    alert("addGlobalAdmin called: " + JSON.stringify(admin));
    setAddGlobalAdminModalOpen(false);
  }

  return (
    <div className={styles.container}>
      <Header
        title="GLOBAL ADMINS"
        onClick={() => history.push("/dreamstream/groups")} // idk why this doesn't work
        children={<></>}
        back={true}
        backTitle="Back to Groups"
      />
      <div className={styles.cardContainer}>
        <Card
          title="ADMINS"
          children={
            <GlobalAdminsList
              admins={placeholderAdmins}
              onClick={clickRemove}
            />
          }
          buttonName="ADD ADMINS"
          onClick={() => setAddGlobalAdminModalOpen(true)}
        />
      </div>

      <AddGlobalAdminModal
        isOpen={addGlobalAdminModalOpen}
        onClose={() => setAddGlobalAdminModalOpen(false)}
        onClick={addGlobalAdmin}
      />

      <RemoveGlobalAdminModal
        isOpen={removeAdminModalOpen}
        onClose={() => setRemoveAdminModalOpen(false)}
        onClick={() => removeAdmin()}
        globalAdminInfo={removeAdminInfo}
      />
    </div>
  );
}
